const style = {
  icon: {
    color: `black`,
    fontSize: `18px`,
    verticalAlign: `text-bottom`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Editor/style/icons.js